import { graphql, useStaticQuery } from 'gatsby';
import { getImage, IGatsbyImageData, ImageDataLike } from 'gatsby-plugin-image';
import { logError } from 'utils/helpers';

import { LineItem } from '../types';

type ProductNode = {
  slug?: string;
  productId: number;
  boxImage: ImageDataLike;
};

const useCartImage = (variant: LineItem): IGatsbyImageData | undefined => {
  const result = useStaticQuery<{
    allContentfulProduct: {
      nodes: ProductNode[];
    };
  }>(graphql`
    query {
      allContentfulProduct {
        nodes {
          slug
          productId
          boxImage {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
  `);

  const product = result.allContentfulProduct.nodes.find(
    (node) =>
      node.slug === variant.product_sku ||
      node.productId === variant.product_id,
  );

  if (product) {
    return getImage(product.boxImage);
  } else {
    logError('could not match product to variant to get boxImage', {
      component: 'hooks/useCartImage',
      method: 'useCartImage',
      product,
      variant,
    });
  }
};

export default useCartImage;
